<ng-template #GenerateReport>
  <div nxRow>
    <div nxCol="12" style="text-align: center;">
      <h3 nxHeadline="subsection-medium" translate>
        policy.insured-trips.generate-report.title</h3>
    </div>
  </div>
  <div nxRow>
    <div nxCol="12">
      <form [formGroup]="formGenerateReport" class="modal-form-report"
        (submit)="submitGenerateReport($event)">
        <nx-formfield
          label="{{ 'policy.insured-trips.data.start-insurance-date' | translate }}">
          <input nxDatefield nxInput [datepicker]="dateDatepickerStart"
            [datefieldFilter]="filterDateBegin" formControlName="dateBegin"
            [parseFormat]="['DD.MM.YYYY', 'D.M.YYYY']" displayFormat="DD.MM.YYYY" />
          <nx-datepicker-toggle [for]="dateDatepickerStart" nxFormfieldSuffix>
          </nx-datepicker-toggle>
          <nx-datepicker #dateDatepickerStart></nx-datepicker>
        </nx-formfield>
        <nx-formfield
          label="{{ 'policy.insured-trips.data.end-insurance-date' | translate }}">
          <input nxDatefield nxInput [datepicker]="dateDatepickerEnd"
            [datefieldFilter]="filterDateEnd" formControlName="dateEnd"
            [parseFormat]="['DD.MM.YYYY', 'D.M.YYYY']" displayFormat="DD.MM.YYYY" />
          <nx-datepicker-toggle [for]="dateDatepickerEnd" nxFormfieldSuffix>
          </nx-datepicker-toggle>
          <nx-datepicker #dateDatepickerEnd></nx-datepicker>
        </nx-formfield>
        <div nxRow>
          <div nxCol="12" class="form-buttons">
            <button nxButton="secondary normal" type="button"
              (click)="closeModal()"><span
                translate>policy.insured-trips.back-btn</span></button>
            <button nxButton="primary normal" type="submit"><span
                translate>policy.insured-trips.generate-report.submit-btn</span></button>
          </div>
        </div>
      </form>
    </div>
  </div>
</ng-template>
